// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { xor } from 'lodash/fp';

// Actions
import { userContactsTrackUserIds } from '../../user/contacts/userContactsActions';

// Selectors
import { isViewingPublicTemplateSelector } from '../../reducers/currentBoardId/currentBoardIdSelector';
import { getTrackedUserIds } from './remoteUsersSelector';

// Hooks
import usePrevious from '../react/usePrevious';

const mapStateToProps = createStructuredSelector({
    trackedUserIds: getTrackedUserIds,
    isViewingPublicTemplate: isViewingPublicTemplateSelector,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchTrackUserContactsIds: (userIds) => dispatch(userContactsTrackUserIds(userIds)),
});

/**
 * This component adds users to the milanote user contacts store provided the currently
 * viewed board is not a public template.
 * This ensures that Milanote staff are not added to the user's contacts.
 */
const UserContactsTracker = (props) => {
    const { trackedUserIds, isViewingPublicTemplate, dispatchTrackUserContactsIds } = props;

    const prevTrackedUserIds = usePrevious(trackedUserIds);

    React.useEffect(() => {
        if (isViewingPublicTemplate) return;

        const newUserIds = xor(prevTrackedUserIds, trackedUserIds);

        if (!newUserIds || !newUserIds.length) return;

        dispatchTrackUserContactsIds(newUserIds);
    }, [trackedUserIds]);

    return null;
};

UserContactsTracker.propTypes = {
    trackedUserIds: PropTypes.array,
    isViewingPublicTemplate: PropTypes.bool,
    dispatchTrackUserContactsIds: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserContactsTracker);
